import { jsx } from "react/jsx-runtime";
import { memo, useRef, useCallback, useEffect } from "react";
import { useGoogleMap, Marker as Marker$2 } from "@react-google-maps/api";
import { SINGLE_PIN_ZOOM } from "./constants.js";
import { setMarkerIcon, getObjectCoordinates } from "./utils.js";
const Marker = ({
  pin,
  isSelected,
  isHovered,
  getImages,
  shouldZoomOnClickPin,
  placemarkSize,
  placemarkHoverSize,
  placemarkActiveSize,
  placemarkOffset,
  placemarkHoverOffset,
  placemarkActiveOffset,
  onHover,
  onSelect
}) => {
  const map = useGoogleMap();
  const currentMarker = useRef();
  const image = getImages(pin);
  const getCurrentIcon = useCallback(() => {
    if (isSelected) {
      return image.active;
    }
    if (isHovered) {
      return image.hover;
    }
    return image.default;
  }, [isSelected, isHovered, image]);
  const getCurrentSize = useCallback(() => {
    if (isSelected) {
      return placemarkActiveSize;
    }
    if (isHovered) {
      return placemarkHoverSize;
    }
    return placemarkSize;
  }, [isSelected, isHovered, placemarkActiveSize, placemarkHoverSize, placemarkSize]);
  const getCurrentOffset = useCallback(() => {
    if (isSelected) {
      return placemarkActiveOffset;
    }
    if (isHovered) {
      return placemarkHoverOffset;
    }
    return placemarkOffset;
  }, [isSelected, isHovered, placemarkActiveOffset, placemarkHoverOffset, placemarkOffset]);
  useEffect(() => {
    if (currentMarker.current) {
      setMarkerIcon(currentMarker.current, getCurrentIcon(), getCurrentSize(), getCurrentOffset());
    }
  }, [getCurrentIcon, getCurrentSize, getCurrentOffset]);
  const onLoad = useCallback(
    (marker) => {
      setMarkerIcon(marker, getCurrentIcon(), getCurrentSize(), getCurrentOffset());
      currentMarker.current = marker;
    },
    [getCurrentIcon, getCurrentSize, getCurrentOffset]
  );
  const onMouseOver = useCallback(
    (e) => {
      if (!currentMarker.current || isSelected) {
        return;
      }
      const position = currentMarker.current.getPosition();
      const coordinates = position && map ? getObjectCoordinates(map, position.lat(), position.lng()) : null;
      if (coordinates) {
        onHover == null ? void 0 : onHover({ id: pin.id, coordinates, domEvent: e.domEvent });
      }
    },
    [isSelected, onHover, pin.id]
  );
  const onMouseOut = useCallback(
    (e) => {
      if (!currentMarker.current) {
        return;
      }
      const position = currentMarker.current.getPosition();
      const coordinates = position && map ? getObjectCoordinates(map, position.lat(), position.lng()) : null;
      if (coordinates) {
        onHover == null ? void 0 : onHover({ id: null, coordinates, domEvent: e.domEvent });
      }
    },
    [onHover]
  );
  const onClick = useCallback(() => {
    if (!currentMarker.current) {
      return;
    }
    onSelect == null ? void 0 : onSelect(!isSelected ? pin.id : null);
    if (!isSelected && shouldZoomOnClickPin) {
      map == null ? void 0 : map.setCenter({ lat: pin.latitude, lng: pin.longitude });
      map == null ? void 0 : map.setZoom(SINGLE_PIN_ZOOM);
    }
  }, [isSelected, onSelect, pin.id, pin.latitude, pin.longitude, shouldZoomOnClickPin, map]);
  return /* @__PURE__ */ jsx(
    Marker$2,
    {
      onLoad,
      onMouseOver,
      onMouseOut,
      onClick,
      position: { lat: pin.latitude, lng: pin.longitude }
    },
    pin.id
  );
};
const Marker$1 = memo(Marker);
export {
  Marker$1 as default
};
//# sourceMappingURL=Marker.js.map
